import type { StringOrVNode } from "@nuxt/ui";

export const capitalize = (str: string): string => {
  if (typeof str !== "string" || str.length === 0) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertToStringObject = (obj: any) => {
  if (obj === undefined) {
    return;
  }
  Object.keys(obj).forEach((key) => {
    obj[key] = String(obj[key]);
  });

  return obj;
};

const copyTextWithExecCommand = (str: string) => {
  const textarea = document.createElement("textarea");
  textarea.value = str;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "0";
  textarea.style.opacity = "0";

  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  const isCopied = (() => {
    try {
      return document.execCommand("copy");
    } finally {
      textarea.remove();
    }
  })();

  if (!isCopied) {
    throw new Error("Unable to copy text to clipboard");
  }
};

export const copyToClipboard = async (
  str: string,
  title: string = "แจ้งเตือน",
  description: StringOrVNode = "คัดลอกสำเร็จ",
  icon: string = "i-lucide-circle-check",
) => {
  const toast = useToast();

  try {
    await navigator.clipboard.writeText(str);
  } catch {
    copyTextWithExecCommand(str);
  }

  toast.add({
    title,
    description,
    icon,
  });
};
